import axios from 'axios';
import appConfig from '@/configs/app.config';
import AxiosRequestIntrceptorConfigCallback from './AxiosRequestIntrceptorConfigCallback';
import AxiosResponseIntrceptorErrorCallback from './AxiosResponseIntrceptorErrorCallback';
import type { AxiosError } from 'axios';

const AxiosBase = axios.create({
  timeout: 60000,
  baseURL: appConfig.apiBaseUrl,
});

AxiosBase.interceptors.request.use(
  (config) => {
    return AxiosRequestIntrceptorConfigCallback(config);
  },
  (error) => {
    return Promise.reject(error);
  },
);

AxiosBase.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    AxiosResponseIntrceptorErrorCallback(error);
    return Promise.reject(error);
  },
);

export default AxiosBase;
